import { useEffect } from 'react';
import { aquecerPresentes } from './presentesCache';
import { PRESENTES_SEM_FUNDO_URLS, videoSemFundo } from './presentesSemFundo';

// Mal um ecrã com presentes abre (live, sala, arena, champions, liga), põe os
// vídeos dos presentes a descarregar em segundo plano, para que o primeiro
// presente que chegar toque de imediato em vez de esperar pelo download.
//
// `lista` é opcional: a lista de presentes do ecrã ({ preco, video }). Com
// ela, os mais baratos (os mais enviados) descarregam primeiro.
export function useAquecerPresentes(lista) {
  useEffect(() => {
    const prioridade = Array.isArray(lista)
      ? [...lista]
          .filter((p) => p && p.video)
          .sort((a, b) => (Number(a.preco) || 0) - (Number(b.preco) || 0))
          .map((p) => videoSemFundo(p.video))
          .filter(Boolean)
      : [];
    return aquecerPresentes(PRESENTES_SEM_FUNDO_URLS, { prioridade });
    // A lista é uma constante do módulo em todos os ecrãs: aquecer uma vez por montagem chega.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
